import React, { useEffect } from 'react';
export function usePrevious(value) {
    const ref = React.useRef(undefined);
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
export default usePrevious;
